module.exports = __webpack_public_path__ + "static/media/portfolio5.1b2e243b.png";